<template>
  <v-snackbar v-model="visible" :timeout="-1" top>
    {{ $t('content') }}

    <template v-slot:action="{ attrs }">
      <v-btn color="blue" text v-bind="attrs" :loading="true"></v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import notificationMixin from '../notification-mixin'

export default {
  name: 'DownloadingUpdateNotification',
  mixins: [notificationMixin('downloadingUpdate')]
}
</script>

<i18n>
{
	"en": {
		"content": "Downloading update, please wait."
	},
	"es": {
		"content": "Descargando una actualización, espere."
	},
	"fr": {
		"content": "Téléchargement d'une mise à jour, merci de patienter."
	},
	"it": {
		"content": "Download dell'aggiornamento in corso, attendi."
	},
	"pt": {
		"content": "A transferir a atualização, por favor aguarde."
	},
	"pl": {
		"content": "Pobieranie aktualizacji, proszę czekać."
	}
}
</i18n>

